import { Dispatch } from "redux";

import {
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    LOGOUT
  } from "../constants";

  import AuthService from "../../services/auth.service";
    
  const loginSuccess = (payload: any) => ({
    type: LOGIN_SUCCESS,
    payload,
  });
  
  const loginFailure = () => ({
    type: LOGIN_FAILURE,
    payload: {
      error: 'No esta autorizado.'
    },
  });

  const logoutSuccess = () => ({
    type: LOGOUT
  });

  export const login = (token: string, refreshToken: string) => (dispatch: Dispatch) => {
    let user = AuthService.login(token, refreshToken);
    if(user){
        dispatch(loginSuccess({ user }))
    } else {
        dispatch (loginFailure());
    }
  };
  
  export const logout = () => (dispatch: Dispatch) => {   
    AuthService.logout(() => {      
      dispatch(logoutSuccess());
      window.location.href = AuthService.logoutUrl;
    });
  };